import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Translate from '../../../../../components/Translate';
import config from '../../../../../config';
import moment from 'moment';
import {getContactFromConversation} from '../../../../../utils/ComponentUtilFunctions';
import {convertFormBackendDate} from '../../../../../utils/General';
import EndConversation from "../../../../../assets/images/end-conversation.png";
import InfoIcon from "../../../../../assets/images/info-white.png";
import Ticket from "../../../../../assets/images/wirte.png"
import BlockUsers from '../../../../../assets/images/block-user.png';
import Info from '../../../../../assets/images/info.png';
import Forward from "../../../../../assets/images/forward.png";
import ForwardDialog from "./ForwardDialog";
import ContextMenu from "../../../../../components-new/ContextMenu";
import {getUserByEmails} from "../../../../../services/company/api";
import PlatformIcon from "../../../../../components-new/PlatformIcon";
import ContactAvatar from "../../../../../components/ContactAvatar";
import Tooltip from "../../../../../components-new/Tooltip";
import ChatMoreInfoModal from "../../../../../components/ChatMoreInfoModal";

const defaultChatColor = 'rgb(235, 238, 249)';
const afkChatColor = 'linear-gradient(135deg, #ffe5e5, #ffd6d6, #ffcccc)';

const styles = {
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        position: 'relative',
        height: '156px',
        padding: '10px 5px',
        borderRadius: '10px',
        marginBottom: '3px',
        backgroundColor: defaultChatColor,
    },
    wrapperIsSelected: {
        borderLeft: '6px solid rgb(4, 62, 92)',
    },
    avatarWrapper: {
        marginRight: '5px',
        marginLeft: '5px',
    },
    avatar: {
        color: '#fff',
        backgroundColor: 'rgb(4, 62, 92)',
        width: '45px',
        height: '45px',
        marginLeft: '8px',
    },
    messageInfoWrapper: {
        flexGrow: 1,
    },
    name: {
        flexGrow: 1,
        fontSize: '14px',
        maxWidth: 190,
        fontWeight: 600,
        overflow: 'hidden',
        wordWrap: 'break-word',
        textOverflow: 'ellipsis',
        lineHeight: '20px',
    },
    lastMessageTime: {
        fontSize: '11px',
    },
    lastMessage: {
        flexGrow: 1,
        fontSize: '11px',
        lineHeight: '18px',
        maxWidth: '191px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    unreadCount: {
        width: 17,
        height: 17,
        fontSize: '10px',
        borderRadius: '50%',
        backgroundColor: '#FF3636',
        color: '#FFFFFF',
    },
};

class ChatUserListContact extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showContextMenu: false,
            contextMenuPosition: {x: 0, y: 0},
            isSoundEnabled: true,
            dialogState: {isOpen: false, mode: ''},
            members: [],

        };
    }

    openDialog = (mode) => {
        const {conversation} = this.props;

        let filteredMembers = [];
        if (conversation.platform !== config.platformsMap.company) {
            filteredMembers = this.filterMembersToForward();
        }

        getUserByEmails(filteredMembers.map(m => m.email)).then(data => {
            const updatedData = data.map(user => ({
                ...user,
                id: user.platformId
            }));
            const sortedData = updatedData.sort((a, b) => a.currentStatus.localeCompare(b.currentStatus));
            this.setState({members: sortedData});
        });

        this.setState({dialogState: {isOpen: true, mode}});
    };

    closeDialog = () => {
        this.setState({dialogState: {isOpen: false, mode: ''}});
    };

    componentDidUpdate() {
        if (this.props.conversation.id) {
            const stored = sessionStorage.getItem(`soundEnabled-${this.props.conversation.id}`);
            this.setState({isSoundEnabled: stored !== 'false'});
        }
    }

    handleContextMenu = (event) => {
        event.preventDefault();

        const clickX = event.pageX;
        const clickY = event.pageY;
        const screenW = window.innerWidth;
        const screenH = window.innerHeight;
        const menuW = 150;
        const menuH = 40;

        let x = clickX;
        let y = clickY;

        if ((clickX + menuW) > screenW) x = screenW - menuW - 10;
        if ((clickY + menuH) > screenH) y = screenH - menuH - 10;

        this.setState({
            showContextMenu: false
        }, () => {
            this.setState({
                showContextMenu: true,
                contextMenuPosition: {x, y}
            });
        });

    };

    handleEndConversation = () => {
        const {endConversationForOperator, conversation} = this.props;
        endConversationForOperator(conversation);
        this.setState({showContextMenu: false});
    };

    handleTicketClick = () => {
        const {ticketClick, conversation} = this.props;
        ticketClick(conversation);
        this.setState({showContextMenu: false});
    };

    handleBlockUserClick = () => {
        const {blockUserClick, conversation} = this.props;
        blockUserClick(conversation);
        this.setState({showContextMenu: false});
    };

    filterMembersToForward = () => {
        const {conversation: {companyId}, company: {members}, user} = this.props;
        const {statusMap} = config;
        return members.filter(member =>
            member.id !== user.id && member.status === statusMap.enabled && (member.subCompanyIds.includes(companyId) || member.authorities[0] === config.rolesMap.admin || member.authorities[0] === config.rolesMap.owner));
    };

    openTrModal = (conversation) => {
        this.setState({
            selectedChat: conversation,
            isInnerModalOpen: true
        });
    };

    closeInnerModal = () => {
        this.setState({
            selectedChat: null,
            isInnerModalOpen: false
        });
    };

    showConversationHistory = (conversationInfo) => {
        const {selectConversation, clearSelectedConversationFromStore} = this.props;
        clearSelectedConversationFromStore();
        selectConversation({
            id: conversationInfo.id,
            companyId: conversationInfo.companyId,
            platform: conversationInfo.platform,
            userFirstName: conversationInfo.userFirstName,
            userLastName: conversationInfo.userLastName,
            userThumbUrl: conversationInfo.userThumbUrl,
        });
    };

    render() {
        const {
            conversation,
            selectConversation,
            isSelected,
            isSupervisor,
            user,
            forwardConversation,
            company,
        } = this.props;

        const {dialogState, members, isInnerModalOpen} = this.state;

        let features = []
        if (company) {
            features = company.tariff.features
        }

        const contact = getContactFromConversation(conversation);
        const lastMessage = {
            type: conversation.type,
            text: conversation.text,
            date: conversation.date,
            attachmentId: conversation.attachmentId,
        };

        const firstName = contact.firstName || '';
        const lastName = contact.lastName || '';
        const messageTime = lastMessage.date ? moment(convertFormBackendDate(lastMessage.date)).format('H:mm') : '';
        let contactText;
        if (lastMessage.type == null) {
            contactText = <Translate text="noMessages"/>;
        } else if (lastMessage.type === 'TEXT' || lastMessage.type === 'QUICK_REPLY') {
            contactText = lastMessage.text;
        } else {
            contactText = <Translate text="attachment"/>;
        }

        const hasUnReadMessages = !!conversation.unread;
        const wrapperStyles = [styles.wrapper];

        if (isSelected) wrapperStyles.push(styles.wrapperIsSelected);

        if (conversation.afk) {
            wrapperStyles.push({
                background: afkChatColor,
                opacity: '0.7'
            });
        } else {
            wrapperStyles.push({
                background: defaultChatColor,
            });
        }

        return (
            <React.Fragment>
                <li
                    role="menuitem"
                    onContextMenu={this.handleContextMenu}
                    onClick={() => selectConversation(conversation)}
                    style={wrapperStyles}
                    className="chat-list-item"
                >
                    <div style={{marginLeft: '5px'}}>
                        {conversation.platform === config.platformsMap.company && (
                            <ContactAvatar contact={contact} wrapperStyles={styles.avatar} inChatMenu={true}/>
                        )}
                        {conversation.platform !== config.platformsMap.company && (
                            <PlatformIcon conversation={conversation} size={40}/>
                        )}
                    </div>
                    <div style={{flexGrow: 1}} className="messages-info">
                        <div className="title"
                             style={{display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
                            <span className="name" style={{...styles.name, display: 'flex', flexDirection: 'column'}}>
                                <p
                                    style={{
                                        maxWidth: '400px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis'
                                    }}
                                >
                                  {`${firstName} ${lastName}`}
                                </p>
                                {conversation.companyName && conversation.companyName !== "null" && (
                                    <span style={{
                                        fontSize: '9px',
                                        maxWidth: '400px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis'
                                    }}><Translate
                                        text={'bot'}/> : {conversation.companyName}
                                    </span>)}
                                {contact.visitorEmail && contact.visitorEmail !== "null" && (
                                    <span style={{
                                        fontSize: '9px', maxWidth: '400px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis'
                                    }}><Translate text={'email'}/> : {contact.visitorEmail}
                                    </span>)}
                                {contact.visitorPhoneNumber && contact.visitorPhoneNumber !== "null" && (
                                    <span style={{
                                        fontSize: '9px', maxWidth: '400px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis'
                                    }}><Translate
                                        text={'phoneNumber'}/> : {contact.visitorPhoneNumber}</span>)}
                                {conversation.lastOperatorName && conversation.status === config.conversationStatuses.unManaged && (
                                    <span style={{
                                        display: 'flex',
                                        maxWidth: '191px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        flexGrow: 1,
                                        fontSize: '9px'
                                    }}><Translate text={'lastOperator'}/> : {conversation.lastOperatorName}</span>)}
                                {isSupervisor && (
                                    <span style={{
                                        display: 'flex',
                                        maxWidth: '191px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        flexGrow: 1,
                                        fontSize: '9px'
                                    }}><Translate text={'op.'}/> : {conversation.lastOperatorName}</span>)}
                            </span>
                            <p style={styles.lastMessageTime}>{messageTime}</p>
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
                            <span style={styles.lastMessage}>{contactText}</span>
                            {hasUnReadMessages ? (
                                <div style={styles.unreadCount}
                                     className="centered-flex-container">{conversation.unread}</div>
                            ) : (
                                <div style={{height: '1.2rem', width: '1.2rem'}}></div>
                            )}
                        </div>
                    </div>

                    {conversation.platform !== config.platformsMap.company && (
                        <div onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                             style={{position: 'absolute', top: 5, right: 5}}>
                            <Tooltip text={'chatContactItemInfo'} prefix={config.messagesPageDefaultSize}>
                                <span>
                                 <img width={17} height={17} src={Info}/>
                                </span>
                            </Tooltip>
                        </div>
                    )}


                </li>
                {conversation.platform !== config.platformsMap.company && this.state.showContextMenu && (
                    <ContextMenu
                        position={this.state.contextMenuPosition}
                        onClose={() => this.setState({showContextMenu: false})}
                        items={[
                            {
                                key: 'end',
                                label: <Translate text="endConversation"/>,
                                icon: EndConversation,
                                onClick: this.handleEndConversation
                            },
                            {
                                key: 'ticket',
                                label: <Translate text="notes"/>,
                                icon: Ticket,
                                onClick: this.handleTicketClick
                            },
                            ...(conversation.status !== config.conversationStatuses.unManaged && features.includes(config.features.CONVERSATION_FORWARD) ? [{
                                key: 'forward',
                                label: <Translate text="forward"/>,
                                icon: Forward,
                                onClick: this.openDialog
                            }] : []),
                            ...(features.includes(config.features.BLACK_LIST) ? [{
                                key: 'block',
                                label: <Translate text="blockUser"/>,
                                icon: BlockUsers,
                                onClick: this.handleBlockUserClick
                            }] : []),
                            {
                                key: 'info',
                                label: <Translate text="info"/>,
                                icon: InfoIcon,
                                onClick: this.openTrModal
                            },
                        ]}
                    />
                )}


                {conversation.platform !== config.platformsMap.company && (
                    <ForwardDialog
                        conv={conversation}
                        state={dialogState}
                        close={this.closeDialog}
                        contactList={members}
                        contactClick={forwardConversation}
                        dialogMode={dialogState.mode}
                        user={user}
                        conversation={conversation}
                    />
                )}

                {isInnerModalOpen && (
                    <ChatMoreInfoModal
                        isOpen={true}
                        onRequestClose={this.closeInnerModal}
                        company={company}
                        showConversationHistory={this.showConversationHistory}
                        conversation={conversation}
                    />
                )}

            </React.Fragment>
        );
    }
}

ChatUserListContact.propTypes = {
    conversation: PropTypes.object.isRequired,
    isSelected: PropTypes.bool.isRequired,
    selectConversation: PropTypes.func.isRequired,
    endConversationForOperator: PropTypes.func,
    isSupervisor: PropTypes.bool,
    user: PropTypes.object,
};

export default Radium(ChatUserListContact);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/ChatContact.jsx